import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { errorText } from "../lib/api";
import Logo from "../components/Logo";

export default function OwnerLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            const res = await api.post("/owner/login", { email, password });
            localStorage.setItem("owner_token", res.data.token);
            navigate("/owner", { replace: true });
        } catch (err) {
            setError(errorText(err, "البريد أو كلمة المرور غير صحيحة"));
        } finally {
            setLoading(false);
        }
    };

    const inputCls =
        "w-full mt-3 px-4 py-3 bg-[var(--bg)] border-2 border-[var(--border-subtle)] rounded-xl focus:outline-none focus:border-brand";

    return (
        <div data-testid="owner-login-page" className="min-h-[80vh] flex items-center justify-center px-4 py-12">
            <form onSubmit={submit} className="surface-card p-6 sm:p-8 w-full max-w-sm">
                <div className="flex justify-center mb-4">
                    <Logo size={64} />
                </div>
                <h1 className="text-2xl font-black text-text-main text-center">لوحة صاحب المطعم</h1>
                <p className="text-text-muted text-center text-sm mt-1">سجّل الدخول لإدارة الطلبات</p>

                <input
                    type="email"
                    dir="ltr"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="owner-email"
                    placeholder="البريد الإلكتروني"
                    className={`${inputCls} mt-6`}
                />
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    data-testid="owner-password"
                    placeholder="كلمة المرور"
                    className={inputCls}
                />

                {error && (
                    <div data-testid="owner-login-error" className="text-red-600 text-sm mt-3 text-center font-bold">
                        {error}
                    </div>
                )}

                <button
                    type="submit"
                    disabled={loading || !email || !password}
                    data-testid="owner-login-submit"
                    className="btn-brand w-full mt-6 disabled:opacity-50"
                >
                    {loading ? (
                        <><i className="fa-solid fa-spinner fa-spin ms-2" /> جاري الدخول...</>
                    ) : (
                        <><i className="fa-solid fa-right-to-bracket ms-2" /> دخول</>
                    )}
                </button>
            </form>
        </div>
    );
}
